module.exports = __webpack_public_path__ + "img/Meca_app_moteur_TB_008.41c49618.jpg";